import React, { useEffect } from "react";
import { t } from "i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import C from "Constants";
import ScriptInjector from "helpers/ScriptInjector";
import useQueryParam from "modules/dine-in/useQueryParam";
import { ErrorMessage } from "components/checkout/CardWidgets";
import StripeForm from "./stripe/StripeForm";
import CheckoutDotComContainer from "./CheckoutDotCom";
import { logPopupError } from "utils/Utils";
import usePayByPaymentMethod from "features/payment-helpers/helpers/payment_helpers/payby/payby.payment";

const LoadingPayByContainer = () => {
  return (
    <div className="h-100 border border-gray-200 rounded-md bg-gray-100">
      <div className="text-center text-gray-500">
        {t("Preparing Payment")}...
      </div>
    </div>
  );
};

const PayByContainer = ({ isNewUI = false,
  integrationsByName,
  redirectLink,
  captureCheckoutDotComPayment,
  setcardProcessing=()=>{},
  handleSuceessOrderRoute=()=>{},
}) => {

  const { paybyPaymentModalData } = useSelector(
    (state) => state.PaymentMethodReducer
  );
  const { selectedStore } = useSelector((state) => state.store);
  const { DomainType } = useSelector((state) => state.AppReducer);
  const { orderGrossAmount, totalOrdersGrossAmount, isSplitted, split } = useSelector((state) => state?.cart);
  const { ordered } = useSelector((state) => state.order);

  const { process_payby_payment_outlet_based } = usePayByPaymentMethod(setcardProcessing , handleSuceessOrderRoute);
  
  const queryParam = useQueryParam();
  const params = useParams();

  const handlePayByInit = () => {
    if (!window.PayBy) {
      console.error("PayBy SDK not loaded");
      return;
    }

    if (typeof window.PayBy.createIframe !== "function") {
      console.error("PayBy.createIframe is not a function");
      return;
    }

    const tokenUrl = paybyPaymentModalData?.data?.interActionParams?.tokenUrl;
    if (!tokenUrl) {
      console.error("PayBy tokenUrl is missing");
      return;
    }

    try {
      const successPath =
        DomainType === C.TEMPORARAY_DOMAIN
          ? `/${params.domainName}/dine-in/order/payment-success`
          : "/dine-in/order/payment-success";

      window.PayBy.createIframe({
        id: "payby-container",
        lang: "en",
        tokenUrl: tokenUrl,
        error: function (msg) {
          console.log("PayBy error:", { msg });
          logPopupError(
            t("Card Payment Declined Please Use Another Card!"),
            true
          );
        },
        redirectUrl: `${window.location.origin}${successPath}?${queryParam}`,
        notifyUrl: `${process.env.REACT_APP_BASE_API_URL}payment-gateway/payby/payment-intent-webhook`,
      });
    } catch (error) {
      console.error("Error initializing PayBy:", error);
    }
  };

  const createPayByPaymentIntent = async ()=>{
    try {
       const amountTobePaid = parseFloat(
         isSplitted
         ? split?.totalAmount
         : ordered.allOrders.length > 0
         ? totalOrdersGrossAmount
         : orderGrossAmount
       ) || 0;
       if (amountTobePaid > 0) {
        await process_payby_payment_outlet_based({
          amountTobePaid: amountTobePaid,
          selectedStore: selectedStore,
        });
       }  
     } catch (error) {
      console.log(error)
     }
    
  }

  useEffect(() => {
    createPayByPaymentIntent();
  }, []);

  if (paybyPaymentModalData.isLoading) {
    return <LoadingPayByContainer />;
  }

  if (!paybyPaymentModalData.data) {

    return (
      <>
        {
          integrationsByName[C.STRIPE] ?
            <StripeForm isNewUI={isNewUI} />
            :
            integrationsByName[C.CHECKOUT_DOT_COM] ?
              <CheckoutDotComContainer
                capturePayment={(token) => captureCheckoutDotComPayment(token, redirectLink)}
                redirectLink={redirectLink}
              />
              :
              <ErrorMessage message="Sorry, PayBy is not available at the moment. Please try again later." />
        }

      </>
    );
  }

  return (
    <div
      className={`h-100  border border-gray-200 rounded-md bg-gray-100  ${isNewUI ? "" : "mx-4 mb-3"
        }`}
    >
      <div
        style={{ height: "450px" }}
        className="h-100"
        id="payby-container"
      ></div>
      <ScriptInjector
        scriptSrc="https://checkout.payby.com/sdk/payby-sdk.umd.js"
        onLoad={handlePayByInit}
      />
    </div>
  );
};

export default PayByContainer;
